module.exports = __webpack_public_path__ + "img/picture.49e43e59.jpg";